import React, { useEffect, useRef, useState } from "react";
import { debounce } from "../@utils/debounce";
import { isBrowser } from "../isBrowser";

const getWindowHeight = () => {
  return (
    (isBrowser && document.documentElement.clientHeight) || window.innerHeight
  );
};

export interface FullHeightProps extends React.ComponentPropsWithoutRef<"div"> {}

/**
 * @deprecated 代わりにCSSの `100dvh` を利用してください。
 */
export const FullHeight = ({ style, ...props }: FullHeightProps) => {
  const [height, setHeight] = useState("100vh");
  //@see https://gist.github.com/hrdtbs/1da2db1b01f9a4e2872e5455127e8b7a
  const { current: updateStyle } = useRef(
    debounce(() => {
      const height = getWindowHeight();
      setHeight(`${height}px`);
    }, 100),
  );
  useEffect(() => {
    if (!isBrowser) return;
    updateStyle();
    window.addEventListener("resize", updateStyle);
    return () => {
      window.removeEventListener("resize", updateStyle);
    };
    // eslint-disable-next-line react-hooks/refs
  }, [updateStyle]);

  return <div style={{ ...style, height }} {...props} />;
};
